export default class TrackedRelease {
    public name: string = '';
    public version: string = '';

    public constructor(partial?: Partial<TrackedRelease>) {
        Object.assign(this, partial);
    }
}